import { SharedActionTypes } from '@SharedStores/shared.action-types'

const initialStates = {
    clientLoading: false,
    pageLoading: false,
}

const LoadingReducer = (state = initialStates, action: any) => {
    switch (action.type) {
        case SharedActionTypes.SET_CLIENT_LOADING:
            return {
                ...state,
                clientLoading: action.payload,
            }
        case SharedActionTypes.SET_PAGE_LOADING:
            return {
                ...state,
                pageLoading: action.payload,
            }

        default:
            return { ...state }
    }
}

export default LoadingReducer
